export interface RouteStopTaskFieldDTO {
  id: string;
  label: string;
  type: string;
  value: string | string[];
  is_custom_field: boolean;
}

export interface RouteStopTaskFieldProps {
  id: string;
  label: string;
  type: string;
  value: string | string[] | number[] | number | null;
  is_custom_field: boolean;
}

export class RouteStopTaskField implements RouteStopTaskFieldProps {
  id: string;
  label: string;
  type: string;
  value: string | string[] | number[] | number | null;
  is_custom_field: boolean;

  constructor(props: RouteStopTaskFieldProps) {
    this.id = props.id;
    this.label = props.label;
    this.type = props.type;
    this.value = props.value;
    this.is_custom_field = props.is_custom_field;
  }

  static create(props: RouteStopTaskFieldProps) {
    return new RouteStopTaskField(props);
  }
}
